import { MARKETPLACE } from "constants/action-types";
import { EventTypes } from "redux-segment";

export const trackConnectionError = () => ({
    // TODO: Make implicit Segment log
    type: MARKETPLACE.CONNECT_ERROR,
    meta: {
        analytics: {
            eventType: EventTypes.track,
            eventPayload: {
                error: "Marketplace connection error",
            },
        },
    },
});
